import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import APIAmplify from '@aws-amplify/api';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { onStreamMessageChatAIResponse } from '@/graphql/subscriptions';
import LoadingChatAIMessage from '../LoadingChatAIMessage';
import { cloneDeep } from 'lodash';
import Constant from '@/common/constant/Constant';
import { buildConfirmIssuesResolvedMessage } from '@/component/publicPages/chatBot/handler/ChatBoxHandler';
import AIResponse from '@/component/chatAI/element/AIResponse';

WaitingGPTResponseMessage.propTypes = {
    setListMessageContent: PropTypes.func,
    setIsEnableBtnSend: PropTypes.func,
    idOfResponseMessage: PropTypes.any,
    scrollToBottom: PropTypes.any,
    isFromChatBot: PropTypes.bool,
    categoryIdSelected: PropTypes.any,
    formQASystem: PropTypes.any,
    usingAI: PropTypes.any,
};

export default function WaitingGPTResponseMessage({
    setListMessageContent,
    setIsEnableBtnSend,
    idOfResponseMessage,
    scrollToBottom,
    isFromChatBot,
    categoryIdSelected,
    formQASystem,
    usingAI
}) {
    const [displayedMessages, setDisplayedMessages] = useState('');
    const [listItemMessage, setListItemMessage] = useState([]);

    function unescapeJSONSpecialCharacters(str) {
        // Đảo ngược việc escape dấu gạch chéo
        str = str.replace(/\\\\/g, '\\');
        // Đảo ngược việc escape dấu ngoặc kép
        str = str.replace(/\\"/g, '"');
        // Đảo ngược việc escape dấu nháy đơn
        str = str.replace(/\\'/g, "'");
        // Đảo ngược việc escape ký tự dòng mới
        str = str.replace(/\\n/g, '\n');
        // Thay thế \^^ thành "
        str = str.replace(/\\\^\^/g, '"');
        str = str.replaceAll(/%\^&1/g, "'");
    
        return str;
    }

    function sortByIndex(array) {
        array.sort((a, b) => {
            return a.index - b.index;
        });
        return array;
    }

    const getFullMessage = (listMessage) => {
        let message = '';
        listMessage?.forEach(messageObject => {
            if(!messageObject.isEnd){
                message += messageObject.message
            }
        });
        return message;
    }

    useEffect(() => {
        let listMessageClone = cloneDeep(listItemMessage);
        if (!Utils.isEmptyArray(listItemMessage)) {
            listMessageClone = sortByIndex(listMessageClone);
            let message = '';
            for (let index = 0; index < listMessageClone.length; index++) {
                const itemMessage = listMessageClone[index];
                if (itemMessage.index == Number(index)) {
                    if (itemMessage.isEnd) {
                        message = getFullMessage(listMessageClone);
                        console.log('message :>>----------- ', message);
                        let responseMessage = {
                            isFromMe: false,
                            content: message,
                            dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                            messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE
                        };
                        setIsEnableBtnSend(true);
                        if(isFromChatBot) {
                            updateMessageProblemResolved(responseMessage);
                        } else {
                            updateLastMessage(responseMessage, itemMessage.isAddNewWaitingMessage);
                        }
                        break;
                    } else {
                        message += itemMessage.message;
                    }
                } else {
                    break;
                }
            }
            setDisplayedMessages(message);
            scrollToBottom()
        }
    }, [listItemMessage]);



    useEffect(() => {
        let subscription;
        let timeoutId;

        const createTimeout = () => {
            return setTimeout(() => {
                subscription?.unsubscribe();
                let responseMessage = {
                    isFromMe: false,
                    content: I18n.get('MSG-PROCESSING-TIME-EXCEEDED'),
                    isError: true,
                    dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date())
                };
                updateLastMessage(responseMessage);
                setIsEnableBtnSend(true);
            }, 890000)
        }

        if (idOfResponseMessage) {
            const handleSubscriptionEvent = subscriptionData => {
                let messageObject = subscriptionData?.value?.data?.onStreamMessageChatAIResponse;
                if(messageObject.message === 'WARNING_EXCEED_MAX_TOKEN'){
                    updateMessageExceedMaxToken();
                    return;
                };

                if (
                    messageObject?.message?.includes(I18n.get('MSG_OPEN_AI_API_ERROR_PATH_TERM')) ||
                    messageObject?.message ===
                        I18n.get('MSG-AI-LICENSE-KEY-HAVE-BEEN-INVALID-CONTACT-ADMIN')
                ) {
                    let responseMessage = {
                        isFromMe: false,
                        content: messageObject?.message,
                        isError: true,
                        dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                    };
                    setListMessageContent((prevArray) => {
                        const newArray = [...prevArray];
                        if (newArray.length > 0) {
                            newArray[newArray.length - 1] = responseMessage;
                            return newArray;
                        }
                        return [responseMessage];
                    });
                    setIsEnableBtnSend(false);
                    return;
                }

                if (messageObject.isEnd) {
                    if (messageObject.message === Constant.END_SDAUTO_LOG){
                        setListMessageContent(prevArray => {
                            // Tạo một bản sao của mảng hiện tại
                            let newArray = [...prevArray];
                
                            // Kiểm tra xem mảng có phần tử hay không
                            if (newArray.length > 0) {
                                // Cập nhật giá trị cuối cùng của mảng
                                newArray.pop();

                                return newArray
                            }
                
                            // Trường hợp mảng rỗng, trả về mảng chỉ chứa giá trị mới
                            
                            return prevArray;
                        });

                        setIsEnableBtnSend(true);
                    } else {
                        if (
                            messageObject.message ===
                            I18n.get('MESG_STOP_STREAM_CONTENT_TO_CALL_FUNTION')
                        ) {
                            setListItemMessage(prevListMessage => [
                                ...prevListMessage,
                                { message: 'stop', index: messageObject.seq, isEnd: true, isAddNewWaitingMessage: true }
                            ]);
                        } else {
                            setListItemMessage(prevListMessage => [
                                ...prevListMessage,
                                { message: 'stop', index: messageObject.seq, isEnd: true }
                            ]);
                        }
                    }
                } else {
                    const newMessageIndex = messageObject.seq;
                    const message = messageObject.message;
                    const displayText = unescapeJSONSpecialCharacters(message)
                    setListItemMessage(prevListMessage => [
                        ...prevListMessage,
                        { message: displayText, index: newMessageIndex, isEnd: false }
                    ]);

                    // update timeout when received message
                    if(timeoutId){
                        clearTimeout(timeoutId);
                    };
                    timeoutId = createTimeout()

                }
            };

            subscription = APIAmplify.graphql({
                query: onStreamMessageChatAIResponse,
                variables: { aiChatPostId: idOfResponseMessage },
                authMode: Constant.AUTH_MODE_API_KEY
            }).subscribe({
                next: data => handleSubscriptionEvent(data),
                error: error => {
                    console.error('Subscription error:', error);
                    console.error('Xử lý logic khác:', error);
                    let responseMessage = {
                        isFromMe: false,
                        content: I18n.get('MSG-PROCESSING-TIME-EXCEEDED'),
                        isError: true,
                        dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date())
                    };
                    subscription.unsubscribe();
                    updateLastMessage(responseMessage);
                    setIsEnableBtnSend(true);
                }
            });
        }

        timeoutId = createTimeout()
        return () => {
            if(timeoutId){
                clearTimeout(timeoutId);
            }
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, [idOfResponseMessage]);

    const updateLastMessage = (newValue, isAddNewWaitingMessage = false) => {
        setListMessageContent(prevArray => {
            let newArray = [newValue]

            if (prevArray.length > 0) {
                newArray = [...prevArray];
                newArray[newArray.length - 1] = newValue;

            }

            if (isAddNewWaitingMessage) {
                newArray.push({
                    isFromMe: false,
                    isLoadingMessage: true
                });
            };
            return newArray;
        });
    };

    const updateMessageExceedMaxToken = newValue => {
        setListMessageContent(prevArray => {
            // Tạo một bản sao của mảng hiện tại
            let prevArrayClone = [...prevArray];
            // console.log('nearEndItem :>> ', prevArrayClone);
            // Kiểm tra xem mảng có phần tử hay không
            if (prevArrayClone.length > 1) {
              let nearEndItem = prevArrayClone[prevArrayClone.length-2];
              if(nearEndItem.isHidden){
                nearEndItem.isHidden = false;
                prevArrayClone[prevArrayClone.length-2] = nearEndItem
              }
            }

            // Trường hợp mảng rỗng, trả về mảng chỉ chứa giá trị mới
            return [...prevArrayClone];
        });
    }

    const updateMessageProblemResolved = newValue => {
        const newMessage = buildConfirmIssuesResolvedMessage(categoryIdSelected, formQASystem, null, usingAI);
        newMessage.messageChatAI = '※別の言い回しで再度質問することもできます。';
        setListMessageContent(prevArray => {
            const newArray = [...prevArray];
            if (newArray.length > 0) {
                newArray[newArray.length - 1] = newValue;
                newArray.push(newMessage);
                return newArray;
            }
            return [newValue];
        });

    }

    return (
        <LoadingChatAIMessage
            displayedMessages={
                <AIResponse
                    data={displayedMessages}
                    isWaitingChat={true}
                    isPublicSite={isFromChatBot}
                />
            }
        />
    );
};
